import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAdditionalSetupData, ISimpleEventDetail } from "interfaces";
import { currencySymbol, getFormattedDateTime } from "utills/helpers";

export const TransferTicket = ({
  additionalSetupData,
  eventDetailData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-8 lg:gap-x-6">
        <div className="sm:col-span-2">
          <Label
            required
            id="transfer_ticket.start_transfer_ticket_date"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.startDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.start_transfer_ticket_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="transfer_ticket.end_transfer_ticket_date"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.endDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.end_transfer_ticket_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="transfer_ticket.max_number_of_times_to_transfer_ticket"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.maxNumberOfTimes"
            )}
          />
          {additionalSetupData?.max_number_of_times_to_transfer_ticket}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="transfer_ticket.transfer_ticket_fee"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.transferFee"
            )}
          />
          {additionalSetupData?.transfer_ticket_fee}{" "}
          {currencySymbol(eventDetailData?.currency ?? "")}
        </div>
      </div>
    </div>
  );
};
